export default __webpack_public_path__ + "static/media/starsBranchPeru.e05350be.webp";